// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import breakpoints from "@bg/XDL/PreStyle/breakpoints";

/**
 * To convert string to boolean
 * @param value
 */
export const parseBoolean = (value?: string | null) => (value ? value?.toLowerCase() === "true" : false);

export const isSmallMobileScreen = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

export const isMobileScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

export const isTabletScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 1024px)").matches;

/**
 * we have used this equation vw=(fontSize/viewportWidth) × 100 to adjust font size on tablet screen
 * @param mobile
 * @param tablet
 * @param desktop
 * @returns
 */
export const autoClamp = (mobile: number, tablet: number, desktop: number) => {
    const vw = ((tablet / breakpoints.values[2]) * 100).toFixed(2);
    return `clamp(${mobile}px ,${vw}vw , ${desktop}px)`;
};
